// -----------------------------------------------------------
// FloraIQ - KpiCard Unificado
// -----------------------------------------------------------

export interface KpiCardProps {
  label: string;
  value: string | number;
  icon: string;
  trend?: {
    value: string;
    positive: boolean;
  };
  variant?: "default" | "success" | "info" | "warning" | "danger";
  onClick?: () => void;
}

const variantStyles = {
  default: "bg-white",
  success: "bg-primary-50/50",
  info: "bg-accent-50/50",
  warning: "bg-warning-50/50",
  danger: "bg-danger-50/50",
};

const iconVariantStyles = {
  default: "bg-background-100 text-foreground-600",
  success: "bg-primary-100 text-primary-600",
  info: "bg-accent-100 text-accent-600",
  warning: "bg-warning-100 text-warning-600",
  danger: "bg-danger-100 text-danger-600",
};

export default function KpiCard({ label, value, icon, trend, variant = "default", onClick }: KpiCardProps) {
  return (
    <div
      className={`rounded-card border border-background-200/70 p-4 md:p-5 transition-all duration-200 ${variantStyles[variant]} ${onClick ? "cursor-pointer hover:border-primary-200 hover:shadow-sm" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") onClick(); } : undefined}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm text-foreground-500 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">{label}</p>
          <p className="text-xl md:text-2xl font-bold text-foreground-900 font-heading tabular-nums">
            {typeof value === "number" ? value.toLocaleString("pt-BR") : value}
          </p>
          {trend && (
            <p className={`text-xs mt-1.5 flex items-center gap-1 ${trend.positive ? "text-primary-600" : "text-danger-600"}`}>
              <i className={`${trend.positive ? "ri-arrow-up-line" : "ri-arrow-down-line"} text-xs`}></i>
              {trend.value}
            </p>
          )}
        </div>
        <div className={`w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center shrink-0 ${iconVariantStyles[variant]}`}>
          <i className={`${icon} text-base md:text-lg`}></i>
        </div>
      </div>
    </div>
  );
}